import { render, staticRenderFns } from "./RequestExternalFulfillment.vue?vue&type=template&id=23ed4e20&"
import script from "./request_external_fulfillment.ts?vue&type=script&lang=ts&"
export * from "./request_external_fulfillment.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports